export const DEFAULT_TARGET_SPEED = 4; // mph
export const DEFAULT_TURNING_SPEED = 4; // mph
export const DEFAULT_APPROACH_SPEED = 4; // mph
export const MIN_MACHINE_SPEED = 1; // mph
export const MAX_MACHINE_SPEED = 10; // mph
export const ADMIN_MAX_MACHINE_SPEED = 15; // mph
export const MACHINE_SPEED_INCREMENT = 0.5;
export const WEB_DEMO_ORG_ID = "4b0651ec-cb6a-4a87-b8cc-bc27208eb427";
